export const calculateBMI = (weight: number, height: number): number => {
  return Math.round((weight / height ** 2) * 100000) / 10
}
